// import React, { useState, FormEvent, useContext } from 'react';
// import { Course, UpdateCourseRequest } from '../types/course';
// import { AuthContext } from '../context/AuthContext';
// import DriveFolderSelector from './DriveFolderSelector';
// import '../styles/CourseForm.css';

// // --- DurationInput Component (months + days only) ---
// interface DurationInputProps {
//     label: string;
//     value: { months: number; days: number };
//     onChange: (value: { months: number; days: number }) => void;
//     namePrefix?: string;
// }
// function DurationInput({
//                         label,
//                         value,
//                         onChange,
//                         namePrefix = '',
//                     }: DurationInputProps) {
//     return (
//         <div className="duration-input-group">
//             <label className="course-form-label">{label}</label>
//             <div className="duration-input-row">
//                 <input
//                     type="number"
//                     min={0}
//                     max={11}
//                     value={value.months}
//                     onChange={e =>
//                         onChange({ ...value, months: parseInt(e.target.value, 10) })
//                     }
//                     className="duration-input duration-months"
//                     name={`${namePrefix}Months`}
//                     aria-label="Months"
//                     placeholder="M"
//                     style={{ width: 48, marginRight: 4 }}
//                 />
//                 <span style={{ marginRight: 8 }}>m</span>
//                 <input
//                     type="number"
//                     min={0}
//                     max={30}
//                     value={value.days}
//                     onChange={e =>
//                         onChange({ ...value, days: parseInt(e.target.value, 10) })
//                     }
//                     className="duration-input duration-days"
//                     name={`${namePrefix}Days`}
//                     aria-label="Days"
//                     placeholder="D"
//                     style={{ width: 48 }}
//                 />
//                 <span>d</span>
//             </div>
//         </div>
//     );
// }

// interface Props {
//     course: Course;
//     onSubmit: (id: string, data: UpdateCourseRequest) => Promise<void>;
//     onCancel: () => void;
// }

// export default function EditCourseForm({ course, onSubmit, onCancel }: Props) {
//     const { user } = useContext(AuthContext);
//     const isSuperadmin = user?.role === 'superadmin';
//     const isAdmin = user?.role === 'admin';

//     // Helper to split totalDays into { months, days }
//     const splitDays = (totalDays: number) => ({
//         months: Math.floor(totalDays / 30),
//         days: totalDays % 30,
//     });

//     const [form, setForm] = useState({
//         name: course.name || '',
//         description: course.description || '',
//         baseFee: course.baseFee != null ? String(course.baseFee) : '',
//         telegramServerId: course.telegramServerId || '',
//         maxViewerDiscount:
//             course.maxViewerDiscount != null ? String(course.maxViewerDiscount) : '',
//         // existing course.periodMonths holds total days
//         period: splitDays(course.periodMonths || 0),
//         materialAccessPeriod: splitDays(course.materialAccessPeriod || 0),
//         driveFolderId: course.driveFolderId || '',
//     });
//     const [error, setError] = useState<string>('');
//     const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

//     const handleChange = (
//         e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//     ) => {
//         const { name, value } = e.target;
//         setForm(prev => ({
//             ...prev,
//             [name]:
//                 name === 'baseFee' || name === 'maxViewerDiscount'
//                     ? value.replace(/[^0-9]/g, '')
//                     : value,
//         }));
//     };

//     const handleDurationChange = (
//         field: 'period' | 'materialAccessPeriod',
//         value: { months: number; days: number }
//     ) => {
//         setForm(prev => ({
//             ...prev,
//             [field]: value,
//         }));
//     };

//     const handleFolderSelect = (folderId: string, folderName: string) => {
//         setForm(prev => ({
//             ...prev,
//             driveFolderId: folderId,
//         }));
//     };

//     // Converts duration into total days (1 month = 30 days)
//     const durationToDays = (d: { months: number; days: number }) =>
//         d.months * 30 + d.days;

//     const handleSubmit = async (e: FormEvent) => {
//         e.preventDefault();
//         setError('');
//         setIsSubmitting(true);
//         try {
//             const payload: UpdateCourseRequest = {
//                 name: form.name.trim(),
//                 description: form.description.trim(),
//                 baseFee: Number(form.baseFee) || 0,
//                 periodMonths: durationToDays(form.period),
//                 telegramServerId: form.telegramServerId.trim(),
//                 driveFolderId: form.driveFolderId.trim(),
//                 maxViewerDiscount: 0,
//                 materialAccessPeriod: 0,
//             };

//             // allow both admins and superadmins to set discount & access period
//             if (isSuperadmin || isAdmin) {
//                 payload.maxViewerDiscount = Number(form.maxViewerDiscount) || 0;
//                 payload.materialAccessPeriod = durationToDays(
//                     form.materialAccessPeriod
//                 );
//             } else {
//                 delete (payload as any).maxViewerDiscount;
//                 delete (payload as any).materialAccessPeriod;
//             }

//             await onSubmit(course.id, payload);
//         } catch (err: any) {
//             setError(err.response?.data?.message || err.message);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <div className="course-form-overlay">
//             {isSubmitting && (
//                 <div className="course-form-loading-overlay">
//                     <div className="course-form-loading-spinner">
//                         <div className="spinner"></div>
//                         <p>Updating course...</p>
//                     </div>
//                 </div>
//             )}
//             <div className="course-form-container">
//                 <div className="course-form-header">
//                     <h1 className="course-form-title">Edit {course.name}</h1>
//                 </div>
//                 {error && <div className="course-form-error">{error}</div>}

//                 <form className="course-form-grid" onSubmit={handleSubmit}>
//                     {/* Name */}
//                     <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                         <label className="course-form-label" htmlFor="name">
//                             Name
//                         </label>
//                         <input
//                             id="name"
//                             name="name"
//                             type="text"
//                             className="course-form-input"
//                             value={form.name}
//                             onChange={handleChange}
//                             required
//                         />
//                     </div>

//                     {/* Description */}
//                     <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                         <label className="course-form-label" htmlFor="description">
//                             Description
//                         </label>
//                         <textarea
//                             id="description"
//                             name="description"
//                             className="course-form-input"
//                             value={form.description}
//                             onChange={handleChange}
//                             rows={3}
//                         />
//                     </div>

//                     {/* Base Fee */}
//                     <div className="course-form-group">
//                         <label className="course-form-label" htmlFor="baseFee">
//                             Base Fee
//                         </label>
//                         <input
//                             id="baseFee"
//                             name="baseFee"
//                             type="text"
//                             inputMode="numeric"
//                             pattern="[0-9]*"
//                             className="course-form-input no-spinner"
//                             value={form.baseFee}
//                             onChange={handleChange}
//                             required
//                         />
//                     </div>

//                     {/* Period */}
//                     <div className="course-form-group">
//                         <DurationInput
//                             label="Period"
//                             value={form.period}
//                             onChange={v => handleDurationChange('period', v)}
//                             namePrefix="period"
//                         />
//                     </div>

//                     {/* Telegram, Discount & Access-period for admin + superadmin */}
//                     {(isSuperadmin || isAdmin) ? (
//                         <>
//                             {/* Telegram Server ID */}
//                             <div className="course-form-group">
//                                 <label className="course-form-label" htmlFor="telegramServerId">
//                                     Telegram Server ID
//                                 </label>
//                                 <input
//                                     id="telegramServerId"
//                                     name="telegramServerId"
//                                     type="text"
//                                     className="course-form-input"
//                                     value={form.telegramServerId}
//                                     onChange={handleChange}
//                                 />
//                             </div>

//                             {/* Max Viewer Discount */}
//                             <div className="course-form-group">
//                                 <label
//                                     className="course-form-label"
//                                     htmlFor="maxViewerDiscount"
//                                 >
//                                     Max Viewer Discount
//                                 </label>
//                                 <input
//                                     id="maxViewerDiscount"
//                                     name="maxViewerDiscount"
//                                     type="text"
//                                     inputMode="numeric"
//                                     pattern="[0-9]*"
//                                     className="course-form-input no-spinner"
//                                     value={form.maxViewerDiscount}
//                                     onChange={handleChange}
//                                 />
//                             </div>

//                             {/* Material Access Period */}
//                             <div
//                                 className="course-form-group"
//                                 style={{ gridColumn: '1/-1' }}
//                             >
//                                 <DurationInput
//                                     label="Material Access Period"
//                                     value={form.materialAccessPeriod}
//                                     onChange={v =>
//                                         handleDurationChange('materialAccessPeriod', v)
//                                     }
//                                     namePrefix="materialAccessPeriod"
//                                 />
//                             </div>

//                             {/* Google Drive Folder */}
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <DriveFolderSelector
//                                     selectedFolderId={form.driveFolderId}
//                                     onFolderSelect={handleFolderSelect}
//                                 />
//                             </div>
//                         </>
//                     ) : (
//                         /* Non-admin users get Telegram and Drive folder fields */
//                         <>
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <label className="course-form-label" htmlFor="telegramServerId">
//                                     Telegram Server ID
//                                 </label>
//                                 <input
//                                     id="telegramServerId"
//                                     name="telegramServerId"
//                                     type="text"
//                                     className="course-form-input"
//                                     value={form.telegramServerId}
//                                     onChange={handleChange}
//                                 />
//                             </div>

//                             {/* Google Drive Folder */}
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <DriveFolderSelector
//                                     selectedFolderId={form.driveFolderId}
//                                     onFolderSelect={handleFolderSelect}
//                                 />
//                             </div>
//                         </>
//                     )}

//                     {/* Buttons */}
//                     <div className="course-button-group" style={{ gridColumn: '1/-1' }}>
//                         <button
//                             type="button"
//                             className="course-btn course-btn-cancel"
//                             onClick={onCancel}
//                             disabled={isSubmitting}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="submit"
//                             className="course-btn course-btn-save"
//                             disabled={isSubmitting}
//                         >
//                             {isSubmitting ? 'Updating...' : 'Save'}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// }

// src/components/EditCourseForm.tsx

import React, { FormEvent, useContext, useState } from "react";

import { Course, UpdateCourseRequest } from "../types/course";

import { AuthContext } from "../context/AuthContext";
import {
  encodeMaterialDuration,
  isDevelopmentTimer,
  splitMaterialDuration,
} from "../utils/timerMode";
import DriveFolderSelector from "./DriveFolderSelector";

/* =========================================================
   SHARED STYLES
========================================================= */

const labelClass = "mb-1.5 block text-[13px] font-semibold text-slate-700";

const inputClass =
  "box-border h-10 w-full rounded-[9px] border border-slate-200 bg-white " +
  "px-3 text-[13px] text-slate-900 outline-none transition " +
  "placeholder:text-slate-400 hover:border-slate-300 " +
  "focus:border-slate-400 focus:ring-2 focus:ring-slate-100";

const textareaClass =
  "box-border min-h-[84px] w-full resize-y rounded-[9px] border " +
  "border-slate-200 bg-white px-3 py-2.5 text-[13px] leading-5 " +
  "text-slate-900 outline-none transition placeholder:text-slate-400 " +
  "hover:border-slate-300 focus:border-slate-400 focus:ring-2 " +
  "focus:ring-slate-100";

const numberInputClass =
  "h-full min-w-0 flex-1 border-0 bg-transparent p-0 text-[13px] " +
  "font-semibold text-slate-900 outline-none appearance-none " +
  "[&::-webkit-inner-spin-button]:appearance-none " +
  "[&::-webkit-outer-spin-button]:appearance-none";

const driveSelectorStyles = `
    [&_.course-form-label]:mb-1.5
    [&_.course-form-label]:block
    [&_.course-form-label]:text-[13px]
    [&_.course-form-label]:font-semibold
    [&_.course-form-label]:text-slate-700

    [&_.drive-folder-selector]:flex
    [&_.drive-folder-selector]:flex-col
    [&_.drive-folder-selector]:gap-2

    [&_.drive-selected-banner]:flex
    [&_.drive-selected-banner]:items-center
    [&_.drive-selected-banner]:justify-between
    [&_.drive-selected-banner]:gap-3
    [&_.drive-selected-banner]:rounded-lg
    [&_.drive-selected-banner]:border
    [&_.drive-selected-banner]:border-emerald-200
    [&_.drive-selected-banner]:bg-emerald-50
    [&_.drive-selected-banner]:px-3
    [&_.drive-selected-banner]:py-2
    [&_.drive-selected-banner]:text-[12px]
    [&_.drive-selected-banner]:text-emerald-800

    [&_.drive-clear-btn]:shrink-0
    [&_.drive-clear-btn]:rounded-md
    [&_.drive-clear-btn]:border-0
    [&_.drive-clear-btn]:bg-transparent
    [&_.drive-clear-btn]:px-2
    [&_.drive-clear-btn]:py-1
    [&_.drive-clear-btn]:text-[11px]
    [&_.drive-clear-btn]:font-medium
    [&_.drive-clear-btn]:text-slate-500
    [&_.drive-clear-btn]:transition
    [&_.drive-clear-btn:hover]:bg-white
    [&_.drive-clear-btn:hover]:text-slate-800

    [&_.drive-tabs]:flex
    [&_.drive-tabs]:flex-wrap
    [&_.drive-tabs]:gap-1
    [&_.drive-tabs]:border-b
    [&_.drive-tabs]:border-slate-200

    [&_.drive-tab]:border-0
    [&_.drive-tab]:border-b-2
    [&_.drive-tab]:border-transparent
    [&_.drive-tab]:bg-transparent
    [&_.drive-tab]:px-2.5
    [&_.drive-tab]:py-1.5
    [&_.drive-tab]:text-[12px]
    [&_.drive-tab]:font-medium
    [&_.drive-tab]:text-slate-500
    [&_.drive-tab]:transition
    [&_.drive-tab:hover]:text-slate-900

    [&_.drive-tab-active]:border-slate-900
    [&_.drive-tab-active]:font-semibold
    [&_.drive-tab-active]:text-slate-900

    [&_.drive-breadcrumb]:flex
    [&_.drive-breadcrumb]:min-h-[22px]
    [&_.drive-breadcrumb]:flex-wrap
    [&_.drive-breadcrumb]:items-center
    [&_.drive-breadcrumb]:gap-1
    [&_.drive-breadcrumb]:text-[11px]
    [&_.drive-breadcrumb]:text-slate-500

    [&_.drive-breadcrumb-item]:rounded
    [&_.drive-breadcrumb-item]:border-0
    [&_.drive-breadcrumb-item]:bg-transparent
    [&_.drive-breadcrumb-item]:px-1
    [&_.drive-breadcrumb-item]:py-0.5
    [&_.drive-breadcrumb-item]:text-[11px]
    [&_.drive-breadcrumb-item]:text-slate-700
    [&_.drive-breadcrumb-item]:underline
    [&_.drive-breadcrumb-item]:underline-offset-2

    [&_.drive-breadcrumb-sep]:text-slate-300

    [&_.drive-folder-list]:max-h-[170px]
    [&_.drive-folder-list]:overflow-y-auto
    [&_.drive-folder-list]:rounded-[9px]
    [&_.drive-folder-list]:border
    [&_.drive-folder-list]:border-slate-200
    [&_.drive-folder-list]:bg-white

    [&_.drive-folder-loading]:px-4
    [&_.drive-folder-loading]:py-6
    [&_.drive-folder-loading]:text-center
    [&_.drive-folder-loading]:text-[12px]
    [&_.drive-folder-loading]:text-slate-500

    [&_.drive-folder-empty]:px-4
    [&_.drive-folder-empty]:py-6
    [&_.drive-folder-empty]:text-center
    [&_.drive-folder-empty]:text-[12px]
    [&_.drive-folder-empty]:text-slate-500

    [&_.drive-folder-error]:px-4
    [&_.drive-folder-error]:py-4
    [&_.drive-folder-error]:text-center
    [&_.drive-folder-error]:text-[12px]
    [&_.drive-folder-error]:text-red-600

    [&_.drive-folder-row]:flex
    [&_.drive-folder-row]:min-h-[38px]
    [&_.drive-folder-row]:items-center
    [&_.drive-folder-row]:justify-between
    [&_.drive-folder-row]:gap-2
    [&_.drive-folder-row]:border-b
    [&_.drive-folder-row]:border-slate-100
    [&_.drive-folder-row]:px-3
    [&_.drive-folder-row]:py-1.5
    [&_.drive-folder-row]:transition
    [&_.drive-folder-row:last-child]:border-b-0
    [&_.drive-folder-row:hover]:bg-slate-50

    [&_.drive-folder-row-selected]:bg-emerald-50
    [&_.drive-folder-row-selected:hover]:bg-emerald-50

    [&_.drive-folder-name-btn]:flex
    [&_.drive-folder-name-btn]:min-w-0
    [&_.drive-folder-name-btn]:flex-1
    [&_.drive-folder-name-btn]:items-center
    [&_.drive-folder-name-btn]:gap-2
    [&_.drive-folder-name-btn]:overflow-hidden
    [&_.drive-folder-name-btn]:border-0
    [&_.drive-folder-name-btn]:bg-transparent
    [&_.drive-folder-name-btn]:p-0
    [&_.drive-folder-name-btn]:text-left
    [&_.drive-folder-name-btn]:text-[12px]
    [&_.drive-folder-name-btn]:font-medium
    [&_.drive-folder-name-btn]:text-slate-700
    [&_.drive-folder-name-btn]:whitespace-nowrap
    [&_.drive-folder-name-btn]:text-ellipsis

    [&_.drive-folder-icon]:shrink-0

    [&_.drive-select-btn]:shrink-0
    [&_.drive-select-btn]:rounded-md
    [&_.drive-select-btn]:border
    [&_.drive-select-btn]:border-slate-200
    [&_.drive-select-btn]:bg-white
    [&_.drive-select-btn]:px-2.5
    [&_.drive-select-btn]:py-1
    [&_.drive-select-btn]:text-[11px]
    [&_.drive-select-btn]:font-medium
    [&_.drive-select-btn]:text-slate-600
    [&_.drive-select-btn]:transition
    [&_.drive-select-btn:hover]:bg-slate-100

    [&_.drive-select-btn-active]:border-emerald-700
    [&_.drive-select-btn-active]:bg-emerald-700
    [&_.drive-select-btn-active]:text-white
    [&_.drive-select-btn-active:hover]:bg-emerald-800
`;

/* =========================================================
   ICONS
========================================================= */

const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6 6l12 12M18 6 6 18"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const EditIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="m14.5 5.5 4 4M4 20l3.8-.8L19 8a1.4 1.4 0 0 0 0-2l-1-1a1.4 1.4 0 0 0-2 0L4.8 16.2 4 20Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Spinner = () => (
  <span
    className="
            inline-block h-5 w-5
            animate-spin rounded-full
            border-2 border-slate-200
            border-t-slate-900
        "
    aria-hidden="true"
  />
);

/* =========================================================
   DURATION INPUT
========================================================= */

interface DurationInputProps {
  label: string;

  value: {
    months: number;
    days: number;
  };

  onChange: (value: { months: number; days: number }) => void;

  namePrefix?: string;
}

function DurationInput({
  label,
  value,
  onChange,
  namePrefix = "",
}: DurationInputProps) {
  const useDevelopmentUnits =
    namePrefix === "materialAccessPeriod" && isDevelopmentTimer;
  return (
    <div>
      <label className={labelClass}>{label}</label>

      <div className="grid grid-cols-2 gap-2">
        <div
          className="
                        flex h-10 items-center
                        rounded-[9px]
                        border border-slate-200
                        bg-white px-3
                        transition
                        focus-within:border-slate-400
                        focus-within:ring-2
                        focus-within:ring-slate-100
                    "
        >
          <input
            type="number"
            min={0}
            max={11}
            value={value.months}
            onChange={(e) =>
              onChange({
                ...value,

                months: parseInt(e.target.value, 10) || 0,
              })
            }
            className={numberInputClass}
            name={`${namePrefix}Months`}
            aria-label={`${label} ${useDevelopmentUnits ? "hours" : "months"}`}
          />

          <span className="ml-2 shrink-0 text-[11px] font-medium text-slate-400">
            {useDevelopmentUnits ? "hours" : "months"}
          </span>
        </div>

        <div
          className="
                        flex h-10 items-center
                        rounded-[9px]
                        border border-slate-200
                        bg-white px-3
                        transition
                        focus-within:border-slate-400
                        focus-within:ring-2
                        focus-within:ring-slate-100
                    "
        >
          <input
            type="number"
            min={0}
            max={useDevelopmentUnits ? 59 : 30}
            value={value.days}
            onChange={(e) =>
              onChange({
                ...value,

                days: parseInt(e.target.value, 10) || 0,
              })
            }
            className={numberInputClass}
            name={`${namePrefix}Days`}
            aria-label={`${label} ${useDevelopmentUnits ? "minutes" : "days"}`}
          />

          <span className="ml-2 shrink-0 text-[11px] font-medium text-slate-400">
            {useDevelopmentUnits ? "minutes" : "days"}
          </span>
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   PROPS
========================================================= */

interface Props {
  course: Course;

  onSubmit: (id: string, data: UpdateCourseRequest) => Promise<void>;

  onCancel: () => void;
}

/* =========================================================
   COMPONENT
========================================================= */

export default function EditCourseForm({ course, onSubmit, onCancel }: Props) {
  const { user } = useContext(AuthContext);

  const isSuperadmin = user?.role === "superadmin";

  const isAdmin = user?.role === "admin";

  const splitDays = (totalDays: number) => ({
    months: Math.floor(totalDays / 30),

    days: totalDays % 30,
  });

  const [form, setForm] = useState({
    name: course.name || "",

    description: course.description || "",

    baseFee: course.baseFee != null ? String(course.baseFee) : "",

    telegramServerId: course.telegramServerId || "",

    maxViewerDiscount:
      course.maxViewerDiscount != null ? String(course.maxViewerDiscount) : "",

    period: splitDays(course.periodMonths || 0),

    materialAccessPeriod: splitMaterialDuration(course.materialAccessPeriod || 0),

    driveFolderId: course.driveFolderId || "",
  });

  const [error, setError] = useState<string>("");

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,

      [name]:
        name === "baseFee" || name === "maxViewerDiscount"
          ? value.replace(/[^0-9]/g, "")
          : value,
    }));
  };

  const handleDurationChange = (
    field: "period" | "materialAccessPeriod",

    value: {
      months: number;
      days: number;
    },
  ) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFolderSelect = (folderId: string, folderName: string) => {
    setForm((prev) => ({
      ...prev,

      driveFolderId: folderId,
    }));
  };

  const durationToDays = (d: { months: number; days: number }) =>
    d.months * 30 + d.days;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    setError("");
    setIsSubmitting(true);

    try {
      const payload: UpdateCourseRequest = {
        name: form.name.trim(),

        description: form.description.trim(),

        baseFee: Number(form.baseFee) || 0,

        periodMonths: durationToDays(form.period),

        telegramServerId: form.telegramServerId.trim(),

        driveFolderId: form.driveFolderId.trim(),

        maxViewerDiscount: 0,

        materialAccessPeriod: 0,
      };

      /*
       * Existing behavior preserved:
       * admin + superadmin may update these.
       */
      if (isSuperadmin || isAdmin) {
        payload.maxViewerDiscount = Number(form.maxViewerDiscount) || 0;

        payload.materialAccessPeriod = encodeMaterialDuration(
          form.materialAccessPeriod,
        );
      } else {
        delete (payload as any).maxViewerDiscount;

        delete (payload as any).materialAccessPeriod;
      }

      await onSubmit(course.id, payload);
    } catch (err: any) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const canManageAdvanced = isSuperadmin || isAdmin;

  return (
    <div
      className="
                fixed inset-0 z-[1000]
                flex items-center justify-center
                bg-slate-950/35
                p-4
                backdrop-blur-[1px]
            "
    >
      <div
        className="
                    relative
                    flex
                    max-h-[calc(100vh-32px)]
                    w-full
                    max-w-[880px]
                    flex-col
                    overflow-hidden
                    rounded-[18px]
                    border
                    border-slate-200
                    bg-white
                    shadow-[0_24px_80px_rgba(15,23,42,0.22)]
                "
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-course-title"
      >
        {/* =================================================
                    LOADING
                ================================================= */}

        {isSubmitting && (
          <div
            className="
                            absolute inset-0
                            z-50
                            flex items-center
                            justify-center
                            rounded-[18px]
                            bg-white/90
                            backdrop-blur-[2px]
                        "
          >
            <div className="flex flex-col items-center gap-3">
              <Spinner />

              <div className="text-center">
                <p className="m-0 text-[13px] font-semibold text-slate-900">
                  Updating course
                </p>

                <p className="mb-0 mt-1 text-[12px] text-slate-500">
                  Saving your course changes...
                </p>
              </div>
            </div>
          </div>
        )}

        {/* =================================================
                    HEADER
                ================================================= */}

        <header
          className="
                        flex shrink-0
                        items-start
                        justify-between
                        gap-4
                        border-b
                        border-slate-200
                        px-6 py-4
                        max-sm:px-4
                    "
        >
          <div className="flex min-w-0 items-start gap-3">
            <div
              className="
                                mt-0.5 grid
                                h-9 w-9
                                shrink-0
                                place-items-center
                                rounded-[10px]
                                bg-slate-100
                                text-slate-700
                            "
            >
              <EditIcon />
            </div>

            <div className="min-w-0">
              <h2
                id="edit-course-title"
                className="
                                    m-0
                                    truncate
                                    text-[18px]
                                    font-bold
                                    tracking-[-0.02em]
                                    text-slate-950
                                "
              >
                Edit course
              </h2>

              <p
                className="
                                    mb-0 mt-1
                                    max-w-[540px]
                                    truncate
                                    text-[12px]
                                    text-slate-500
                                "
                title={course.name}
              >
                Update settings for{" "}
                <span className="font-medium text-slate-700">
                  {course.name}
                </span>
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            aria-label="Close"
            className="
                            grid h-8 w-8
                            shrink-0
                            place-items-center
                            rounded-lg
                            border-0
                            bg-transparent
                            p-0
                            text-slate-500
                            transition
                            hover:bg-slate-100
                            hover:text-slate-900
                            disabled:cursor-not-allowed
                            disabled:opacity-50
                        "
          >
            <CloseIcon />
          </button>
        </header>

        {/* =================================================
                    FORM
                ================================================= */}

        <form
          onSubmit={handleSubmit}
          className="
                        flex min-h-0
                        flex-1 flex-col
                        overflow-hidden
                    "
        >
          <div
            className="
                            min-h-0 flex-1
                            overflow-y-auto
                            px-6 py-5
                            max-sm:px-4
                        "
          >
            {error && (
              <div
                className="
                                    mb-4
                                    rounded-[10px]
                                    border
                                    border-red-200
                                    bg-red-50
                                    px-3 py-2.5
                                    text-[12px]
                                    font-medium
                                    text-red-700
                                "
              >
                {error}
              </div>
            )}

            <div className="space-y-5">
              {/* =====================================
                                DETAILS
                            ===================================== */}

              <section>
                <div className="mb-3">
                  <h3 className="m-0 text-[13px] font-bold text-slate-900">
                    Course details
                  </h3>

                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Update the course's basic information.
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                  <div className="md:col-span-2">
                    <label className={labelClass} htmlFor="name">
                      Course name
                      <span className="ml-1 text-red-500">*</span>
                    </label>

                    <input
                      id="name"
                      name="name"
                      type="text"
                      className={inputClass}
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className={labelClass} htmlFor="description">
                      Description
                    </label>

                    <textarea
                      id="description"
                      name="description"
                      className={textareaClass}
                      value={form.description}
                      onChange={handleChange}
                      rows={3}
                      placeholder="Brief course description"
                    />
                  </div>
                </div>
              </section>

              <div className="h-px bg-slate-100" />

              {/* =====================================
                                SETTINGS
                            ===================================== */}

              <section>
                <div className="mb-3">
                  <h3 className="m-0 text-[13px] font-bold text-slate-900">
                    Course settings
                  </h3>

                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Pricing and access duration.
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                  {/* Base Fee */}

                  <div>
                    <label className={labelClass} htmlFor="baseFee">
                      Base fee
                      <span className="ml-1 text-red-500">*</span>
                    </label>

                    <div className="relative">
                      <span
                        className="
                                                    pointer-events-none
                                                    absolute
                                                    left-3
                                                    top-1/2
                                                    -translate-y-1/2
                                                    text-[13px]
                                                    font-semibold
                                                    text-slate-400
                                                "
                      >
                        ₹
                      </span>

                      <input
                        id="baseFee"
                        name="baseFee"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className={`${inputClass} pl-7`}
                        value={form.baseFee}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Period */}

                  <DurationInput
                    label="Course period"
                    value={form.period}
                    onChange={(value) => handleDurationChange("period", value)}
                    namePrefix="period"
                  />

                  {/* Discount */}

                  {canManageAdvanced && (
                    <div>
                      <label className={labelClass} htmlFor="maxViewerDiscount">
                        Max viewer discount
                      </label>

                      <div className="relative">
                        <span
                          className="
                                                        pointer-events-none
                                                        absolute
                                                        left-3
                                                        top-1/2
                                                        -translate-y-1/2
                                                        text-[13px]
                                                        font-semibold
                                                        text-slate-400
                                                    "
                        >
                          ₹
                        </span>

                        <input
                          id="maxViewerDiscount"
                          name="maxViewerDiscount"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className={`${inputClass} pl-7`}
                          value={form.maxViewerDiscount}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  )}

                  {/* Material Access */}

                  {canManageAdvanced && (
                    <DurationInput
                      label="Material access period"
                      value={form.materialAccessPeriod}
                      onChange={(value) =>
                        handleDurationChange("materialAccessPeriod", value)
                      }
                      namePrefix="materialAccessPeriod"
                    />
                  )}
                </div>

                <p className="mb-0 mt-2 text-[10px] text-slate-400">
                  Course duration uses 1 month = 30 days. Material access uses
                  1 month = 1 hour and 1 day = 1 minute.
                </p>
              </section>

              <div className="h-px bg-slate-100" />

              {/* =====================================
                                INTEGRATIONS
                            ===================================== */}

              <section>
                <div className="mb-3">
                  <h3 className="m-0 text-[13px] font-bold text-slate-900">
                    Integrations
                  </h3>

                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Telegram and Google Drive configuration.
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className={labelClass} htmlFor="telegramServerId">
                      Telegram Server ID
                    </label>

                    <input
                      id="telegramServerId"
                      name="telegramServerId"
                      type="text"
                      className={inputClass}
                      value={form.telegramServerId}
                      onChange={handleChange}
                      placeholder="Optional"
                    />
                  </div>

                  <div className={driveSelectorStyles}>
                    <DriveFolderSelector
                      selectedFolderId={form.driveFolderId}
                      onFolderSelect={handleFolderSelect}
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* =================================================
                        FOOTER
                    ================================================= */}

          <footer
            className="
                            flex shrink-0
                            items-center
                            justify-between
                            gap-3
                            border-t
                            border-slate-200
                            bg-white
                            px-6 py-3.5
                            max-sm:flex-col-reverse
                            max-sm:px-4
                        "
          >
            <span className="text-[11px] text-slate-400 max-sm:hidden">
              Changes are saved to this course only.
            </span>

            <div className="flex items-center gap-2 max-sm:w-full">
              <button
                type="button"
                onClick={onCancel}
                disabled={isSubmitting}
                className="
                                    h-10
                                    min-w-[100px]
                                    rounded-[9px]
                                    border
                                    border-slate-200
                                    bg-white
                                    px-4
                                    text-[13px]
                                    font-semibold
                                    text-slate-700
                                    transition
                                    hover:bg-slate-50
                                    disabled:cursor-not-allowed
                                    disabled:opacity-50
                                    max-sm:flex-1
                                "
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={isSubmitting}
                className="
                                    inline-flex
                                    h-10
                                    min-w-[120px]
                                    items-center
                                    justify-center
                                    gap-2
                                    rounded-[9px]
                                    border-0
                                    bg-[#0d162a]
                                    px-4
                                    text-[13px]
                                    font-semibold
                                    text-white
                                    transition
                                    hover:bg-[#172239]
                                    disabled:cursor-not-allowed
                                    disabled:opacity-60
                                    max-sm:flex-1
                                "
              >
                {isSubmitting && (
                  <span
                    className="
                                            inline-block
                                            h-4 w-4
                                            animate-spin
                                            rounded-full
                                            border-2
                                            border-white/30
                                            border-t-white
                                        "
                  />
                )}

                {isSubmitting ? "Saving..." : "Save changes"}
              </button>
            </div>
          </footer>
        </form>
      </div>
    </div>
  );
}
